import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCoins } from "@fortawesome/free-solid-svg-icons";
import BurgerMenuTitle from "../../Component/BurgerMenuTitle/BurgerMenuTitle";
import Style from "./ChooseDiscount.module.css";
import { getDiscountApi } from "../../Api/ClientServices";
import PointSpreadLoading from "react-loadingg/lib/PointSpreadLoading";
import { useHistory } from "react-router";
import { faCopy } from "@fortawesome/free-regular-svg-icons";
import { separate } from "../../Seprate/Seprate";
import { errorToast, succToast } from "../../Toast/Toast";

const ChooseDiscount = () => {
  const [discountCode, setDiscountCode] = useState();
  const [myDiscountCode, setMyDiscountCode] = useState();
  const [copyText] = useState("");
  const history = useHistory();
  useEffect(() => {
    getDiscount();
  }, []);

  const getDiscount = async () => {
    getDiscountApi((succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast(res.message)
          setDiscountCode(res.discount);
          setMyDiscountCode(res.my_discount);
        }else{
          setDiscountCode(res.discount);
          setMyDiscountCode(res.my_discount);
        }
      }else{
        console.error(res)
      }
    })
  };
  const goToNextPage = (id) => {
    history.push({ pathname: "/DiscountCode", state: id });
  };

  const textAreaRef = useRef();
  const CopyHandler = (code) => {
    navigator.clipboard.writeText(code);
    succToast("کپی شد")
  };

  let loading1 = null; 
  let loading2 = null;

  if (myDiscountCode === undefined) {
    return (loading1 = (
      <div className={Style.loadingTest}>
        <PointSpreadLoading color={"#ab0c59"} size={"small"} />
      </div>
    ));
  } else {
    loading1 = (
      <div className={Style.centerHolder}>
        {myDiscountCode.length===0?<p style={{fontFamily:"iran-sans-num",direction:'rtl'}}>کد تخفیفی یافت نشد!</p>:myDiscountCode.map((item, index) => {
          return (
            <div key={index} className={Style.cart}>
              <div className={Style.picHolder}>
                <img src={"/Assets/Images/discount/smile.png"} alt="تخفیف" />
              </div>
              {item.type === "const" ? (
                <h2 className={Style.description}>
                  کد تخفیف {separate(item.value)} تومانی بَرِست برای خریدهای بیش از {separate(item.min_cart)} تومان
                </h2>
              ) : (
                <h2 className={Style.description}>
                  کد تخفیف {item.value} درصدی بَرِست تا سقف {separate(item.max_cart)} تومان
                </h2>
              )}
              <div className={Style.dateHolder}>
                <h3 className={Style.date}>{item.end_date}</h3>
                <span className={Style.until}>اعتبارتا</span>
              </div>
              <div className={Style.useCode}>
                <div>
                  <button
                    onClick={() => CopyHandler(item.code, index)}
                    className={Style.copyBtn}
                  >
                    <FontAwesomeIcon icon={faCopy} />
                  </button>
                  {copyText}
                </div>
                <form id={index}>
                  <textarea
                    className={Style.input}
                    value={item.code}
                    ref={textAreaRef}
                    onChange={() => {}}
                  />
                </form>
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  if (discountCode === undefined) {
    return (loading2 = (
      <div className={Style.loadingTest}>
        <PointSpreadLoading color={"#ab0c59"} size={"small"} />
      </div>
    ));
  } else {
    loading2 = (
      <div className={Style.centerHolder}>
        {discountCode.length===0?<p style={{fontFamily:"iran-sans-num",direction:'rtl'}}>کد تخفیفی یافت نشد!</p>:discountCode.map((item, index) => {
          return (
            <div key={index} className={Style.cart}>
              <div className={Style.picHolder}>
                <img src={"/Assets/Images/discount/smile.png"} alt="تخفیف" />
              </div>
              {item.type === "const" ? (
                <h2 className={Style.description}>
                  کد تخفیف {separate(item.value)} تومانی بَرِست برای خریدهای بیش از {separate(item.min_cart)} تومان
                </h2>
              ) : (
                <h2 className={Style.description}>
                  کد تخفیف {item.value} درصدی بَرِست تا سقف {separate(item.max_cart)} تومان
                </h2>
              )}
              <div className={Style.dateHolder}>
                <h3 className={Style.date}>{item.end_date}</h3>
                <span className={Style.until}>اعتبارتا</span>
              </div>
              <div
                className={Style.coinHolder}
                onClick={() => goToNextPage(item.id)}
              >
                <h3 className={Style.coin}>
                  {separate(item.price)}{" "}
                  <FontAwesomeIcon className={Style.icon} icon={faCoins} />
                </h3>
              </div>
            </div>
          );
        })}
      </div>
    );
  }
  return (
    <section className={Style.pageHolder}>
      <BurgerMenuTitle title={"انتخاب کدتخفیف"} />
      {/* <div className={Style.picTitle}>
        <img src={"/Assets/Images/discount/vector.svg"} alt="تخفیف" />
      </div> */}
      <div className={Style.Holder}>
        <h2 className={Style.title}>کدهای من</h2>
        {loading1}
        <h2 className={Style.title}>کدهای جدید</h2>
        {loading2}
      </div>
    </section>
  );
};
export default ChooseDiscount;
